const pulseBorder = color => ({
  borderTopWidth: '1px',
  borderBottomWidth: '1px',
  borderLeftWidth: '1px',
  borderRightWidth: '1px',
  borderTopStyle: 'solid',
  borderBottomStyle: 'solid',
  borderLeftStyle: 'solid',
  borderRightStyle: 'solid',
  borderTopColor: color,
  borderBottomColor: color,
  borderLeftColor: color,
  borderRightColor: color,
})

const pulseRootState = ({ $theme, $isFocused, $disabled, $isReadOnly }, error, missing) => {
  const { colors } = $theme
  if ($disabled) return { ...pulseBorder(colors.borderPulse), backgroundColor: colors.bgPulseTrack }
  if ($isFocused) {
    return {
      ...pulseBorder(colors.primaryPulse),
      backgroundColor: colors.white,
      boxShadow: $theme.lighting.shadowPulseFocus,
    }
  }
  if (error) return { ...pulseBorder(colors.dangerPulse), backgroundColor: colors.dangerPulseBg }
  if (missing) return { ...pulseBorder(colors.missPulseBorder), backgroundColor: colors.missPulseBg }
  if ($isReadOnly) return { ...pulseBorder(colors.borderPulse), backgroundColor: colors.bgPulseCanvas }

  return {
    ...pulseBorder(colors.borderPulse),
    backgroundColor: colors.white,
    ':hover': pulseBorder(colors.borderPulseHover),
  }
}

const pulseTextColor = ({ $theme, $disabled, $isReadOnly }) => {
  if ($disabled) return $theme.colors.textPulseFaint
  if ($isReadOnly) return $theme.colors.textPulseMuted
  return $theme.colors.textPulseStrong
}

const pulseEnhancerStyle = ({ $theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0,
  backgroundColor: 'transparent',
  fontSize: '13px',
  color: $theme.colors.textPulseMuted,
})

export const SDInputPulseOverrides = (error, missing) => ({
  Root: {
    style: props => ({
      height: '36px',
      paddingLeft: 0,
      paddingRight: '6px',
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      borderBottomLeftRadius: '8px',
      borderBottomRightRadius: '8px',
      boxShadow: 'none',
      ...pulseRootState(props, error ?? props.$error, missing),
    }),
  },
  InputContainer: {
    style: {
      paddingTop: 0,
      backgroundColor: 'transparent',
    },
  },
  Input: {
    style: props => ({
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: '12px',
      paddingRight: '6px',
      fontSize: '14px',
      lineHeight: '20px',
      color: pulseTextColor(props),
      '-webkit-text-fill-color': pulseTextColor(props),
      backgroundColor: 'transparent',
      '::placeholder': {
        color: props.$theme.colors.textPulsePlaceholder,
      },
    }),
  },
  StartEnhancer: { style: pulseEnhancerStyle },
  EndEnhancer: { style: pulseEnhancerStyle },
})

export const SDInputOverrides = (error, hasLabel) => ({
  Root: {
    style: ({ $theme }) => ({
      borderColor: error ? $theme.colors.errorInput : '',
      backgroundColor: error ? 'transparent' : '',
      paddingRight: 0,
    }),
  },
  Input: {
    style: ({ $theme, $disabled }) => ({
      color: $theme.colors.black,
      paddingRight: '.75rem',
      paddingLeft: '.45rem',
      // A paddingTop key, even undefined, replaces baseui's own top padding
      ...(hasLabel ? { paddingBottom: '.125rem' } : { paddingTop: '.6875rem', paddingBottom: '.6875rem' }),
      borderColor: error ? $theme.colors.errorInput : '',
      backgroundColor: error || $disabled ? 'transparent' : '',
    }),
  },
  InputContainer: {
    style: {
      paddingTop: hasLabel ? '0.625rem' : 0,
      backgroundColor: error ? 'transparent' : '',
    },
  },
  EndEnhancer: {
    style: () => ({
      paddingLeft: '2px',
      paddingRight: '1px',
      paddingBottom: '1px',
      paddingTop: '1px',
      backgroundColor: error ? 'transparent' : '',
    }),
  },
})
